import React from 'react';
import PropTypes from 'prop-types';
import { get, uniq } from 'lodash';
import { css, cx } from '@bd/bdui-styles/emotion';
import AccordionToggle from '../../components/AccordionToggle';

const styles = css`
  color: #FFFFFF;
  .SectionAbout_schoolsHead{
    text-align: center;
  }
  .SectionAbout_schoolsSection {
    color: #FFFFFF;
    margin-top: 28px;
    @media (min-width: 768px) {
      margin-top: 52px;
    }
    @media (min-width: 992px) {
      margin-top: 100px;
    }
  }
  .SectionAbout_schoolsHead {
    margin-bottom: 0.4em;
  }
  .SectionAbout_schoolsListPrimary {

  }
  .SectionAbout_schoolsListItemPrimary {
    &:not(:first-child) {
      margin-top: 30px;
    }
    @media (min-width: 768px) {
      &:not(:first-child) {
        margin-top: 32px;
      }
    }
    @media (min-width: 992px) {
      &:not(:first-child) {
        margin-top: 34px;
      }
    }
  }
  .SectionAbout_schoolsListSecondary {
    @media (min-width: 768px) {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -10px -10px;
    }
    @media (min-width: 992px) {
      margin: 0 -14.5px -14.5px;
    }
  }
  .SectionAbout_schoolsListItemSecondary {
    font-size: 15px;
    font-weight: 300;
    letter-spacing: 0.025em;
    line-height: 1.375;
    @media (max-width: 767.98px) {
      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }
    @media (min-width: 768px) {
      font-weight: bold;
      line-height: 1.1;
      height: 52px;
      width: calc(33.333333% - 20px);
      margin: 0 10px 10px;
    }
    @media (min-width: 992px) {
      font-size: 16px;
      height: 55px;
      width: calc(33.333333% - 29px);
      margin: 0 14.5px 14.5px;
    }
  }
  .SectionAbout_schoolDistrict {
    display: block;
    text-align: center;
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 0.022105em;
    line-height: 1.736842;
    margin-bottom: 0.421053em;
    @media (min-width: 768px) {
      font-size: 18px;
    }
    @media (min-width: 992px) {
      font-size: 19px;
    }
  }
  .SectionAbout_schoolsListLink {
    @media (min-width: 768px) {
      padding: 0 16px;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
    @media (min-width: 992px) {
      padding: 0 20px;
    }
  }
`;


function SectionAbout({ className, community }) {
  const schools = get(community, 'schools', []);
  const hasSchools = schools.length > 0;
  const schoolsGrouped = [];
  if (hasSchools) {
    uniq(schools.map(school => school.district)).forEach(district => {
      schoolsGrouped.push({
        district,
        schools: schools.filter(school => get(school, 'district') === district),
      });
    });
  }

  return (
    <div className={cx(styles, className)}>
      <AccordionToggle
        openOnId="schools"
        button="Schools"
        id="schools"
      >
        {
          hasSchools &&
          <div className="SectionAbout_schoolsSection">
            <h2 className="CommunityDetail_sectionHead SectionAbout_schoolsHead GoldText">Schools</h2>
            <ul className="SectionAbout_schoolsListPrimary list-unstyled">
              {
                schoolsGrouped.map(group => (
                  <li className="SectionAbout_schoolsListItemPrimary" key={group.district}>
                    <span className="SectionAbout_schoolDistrict">{group.district}</span>
                    <ul className="SectionAbout_schoolsListSecondary list-unstyled d-flex justify-content-center">
                      {
                        get(group, 'schools', []).map(school => (
                          <li className="SectionAbout_schoolsListItemSecondary" key={school.name}>
                            <a
                              className="SectionAbout_schoolsListLink Btn Hollow"
                              href={school.overviewLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >{school.name}</a>
                          </li>
                        ))
                      }
                    </ul>
                  </li>
                ))
              }
            </ul>
          </div>
        }
      </AccordionToggle>
    </div>
  );
}

SectionAbout.propTypes = {
  className: PropTypes.string,
  community: PropTypes.object.isRequired,
};

SectionAbout.defaultProps = {
  className: undefined,
};

export default SectionAbout;



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/SectionSchools.js